import User from 'flarum/common/models/User';

import Model from 'flarum/common/Model';

export default class Application extends Model {
    name = Model.attribute('name');
    slug = Model.attribute('slug');
    version = Model.attribute('version');
    status = Model.attribute('status');
    isConfigurable = Model.attribute('is_configurable');
    isDownloadable = Model.attribute('is_downloadable');
    configId = Model.attribute('config_id');
    suspendedAt = Model.attribute('suspended_at', Model.transformDate);
    subscribedUntil = Model.attribute('subscribed_until', Model.transformDate);
    license = Model.attribute('license');
    canView = Model.attribute('canView');
    canEdit = Model.attribute('canEdit');
    canCreateKeys = Model.attribute('canCreateKeys');
    canViewHistories = Model.attribute('canViewHistories');
    canViewConfigs = Model.attribute('canViewConfigs');
    defaultConfig = Model.hasOne('defaultConfig');
    //users = Model.hasMany<User>('users');
    //configs = Model.hasMany<User>('configs');
}
